import type { VideoType } from './video';
import VidyardEmbed from './vidyardEmbed';
import VimeoEmbed from './vimeoEmbed';
import YouTubeEmbed from './youtubeEmbed';

type Props = {
  type: VideoType;
  videoId: string;
  width: number | string;
  height: number | string;
  title: string;
  autoPlay?: boolean;
};

const VideoEmbed: React.FC<Props> = ({ type, ...rest }) => {
  if (type === 'youtube') {
    return <YouTubeEmbed {...rest} />;
  }

  if (type === 'vimeo') {
    return <VimeoEmbed {...rest} />;
  }

  if (type === 'vidyard') {
    return <VidyardEmbed {...rest} />;
  }
};

export default VideoEmbed;
